<template>
    <div>
        <buttonlist ref="SetBtn" @help="help"></buttonlist>
        <div style="display: flex">
            <div style="width:85%">
                <table>
                    <tr>
                        <td colspan="4">
                            <el-divider content-position="left">{{$t('getapi[7386]')}}</el-divider>
                        </td>
                    </tr>
                    <tr>
                        <td style="width:50px">{{$t('getapi[4992]')}}</td>
                        <td style="width:100px">
                            <el-select filterable v-model="costyear"  size="mini" style="margin-righ:20px" @change="CheckIsMonthSign">
                                <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </td>
                        <td>{{ $t('getapi[4993]') }}</td>
                        <td style="width:100px">
                            <el-select filterable v-model="costmonth"  size="mini" style="margin-righ:20px" @change="CheckIsMonthSign">
                                <el-option v-for="item in monthList" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-button type="primary" :disabled="!btnexecute" size="mini" @click="newexecuteBalanceVerify(0)">{{$t('getapi[7387]')}}</el-button>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="updateBalancePartCategory" :disabled="!ismonthsign">{{$t('getapi[7385]')}}</el-button>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="avgCostCalc" :disabled="!ismonthsign">{{$t('getapi[7388]')}}</el-button>
                        </td>
                        <td>
                            <el-button type="primary" size="mini" @click="writeBackToOrder" :disabled="!ismonthsign">{{$t('getapi[7389]')}}</el-button>
                        </td>
                    </tr>
                </table>
                <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[7390]')" name="0">
                        <vxe-table
                                :data="dt0"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader0"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7391]')" name="1">
                        <vxe-table
                                :data="dt1"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader1"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7392]')" name="2">
                        <vxe-table
                                :data="dt2"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader2"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7393]')" name="3">
                        <el-tabs :tab-position="'top'" type="card" style="margin-top: 0px" @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[1850]')" name="3">
                                <vxe-table
                                        :data="dt3"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader3"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[7317]')" name="4">
                                <vxe-table
                                        :data="dt4"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader4"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7394]')" name="7">
                        <el-tabs :tab-position="'top'" type="card" style="margin-top: 0px" @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[7395]')" name="7">
                                <vxe-table
                                        :data="dt7"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader7"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[7396]')" name="8">
                                <vxe-table
                                        :data="dt8"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader8"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7397]')" name="6">
                        <vxe-table
                                :data="dt6"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader6"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7398]')" name="5">
                        <vxe-table
                                :data="dt5"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader5"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7399]')" name="11">
                        <el-tabs :tab-position="'top'" type="card" style="margin-top: 0px" @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[7400]')" name="11">
                                <vxe-table
                                        :data="dt11"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader11"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[7401]')" name="9">
                                <vxe-table
                                        :data="dt9"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader9"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[7402]')" name="10">
                                <vxe-table
                                        :data="dt10"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader10"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7403]')" name="12">
                        <vxe-table
                                :data="dt12"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader12"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7404]')" name="13">
                        <el-button type="primary"  size="mini" @click="checkExecuteBalanceVerify" :disabled="dt13.length<1">{{$t('getapi[13507]')}}</el-button>
                        <vxe-table
                                :data="dt13"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 60"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader13"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7405]')" name="14">
                        <vxe-table
                                :data="dt14"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader14"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7406]')" name="15">
                        <el-tabs :tab-position="'top'" type="card" style="margin-top: 0px" @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[235]')" name="15">
                                <el-button type="primary" size="mini" @click="updatePur()">{{ $t('getapi[12272]') }}</el-button>
                                <vxe-table
                                        :data="dt15"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader15"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[7407]')" name="16">
                                <el-button type="primary" size="mini" @click="updateSal()">{{ $t('getapi[12272]') }}</el-button>
                                <vxe-table
                                        :data="dt16"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader16"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[1271]')" name="17">
                                <el-button type="primary" size="mini" @click="updateIss()">{{ $t('getapi[12272]') }}</el-button>
                                <vxe-table
                                        :data="dt17"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader17"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7408]')" name="18">
                        <el-tabs :tab-position="'top'" type="card" style="margin-top: 0px" @tab-click="selectInfo">
                            <el-tab-pane :label="$t('getapi[235]')" name="18">
                                <vxe-table
                                        :data="dt18"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader18"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('getapi[1271]')" name="19">
                                <vxe-table
                                        :data="dt19"
                                        size="mini"
                                        :auto-resize="true"
                                        header-cell-class-name="headerclass"
                                        :height="tableHeight - 60"
                                        show-overflow="tooltip"
                                        stripe
                                        border
                                        resizable>
                                    <vxe-table-column  show-footer-overflow v-for="item in TbHeader19"
                                                       :key="item.Headen"
                                                       :field="item.Headen"
                                                       :title="item.Headcn"
                                                       :align="item.Alignment"
                                                       width="120px"
                                    ></vxe-table-column>
                                </vxe-table>
                            </el-tab-pane>
                        </el-tabs>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[7409]')" name="20">
                        <vxe-table
                                :data="dt20"
                                size="mini"
                                :auto-resize="true"
                                header-cell-class-name="headerclass"
                                :height="tableHeight - 30"
                                show-overflow="tooltip"
                                stripe
                                border
                                resizable>
                            <vxe-table-column  show-footer-overflow v-for="item in TbHeader20"
                                               :key="item.Headen"
                                               :field="item.Headen"
                                               :title="item.Headcn"
                                               :align="item.Alignment"
                                               width="120px"
                            ></vxe-table-column>
                        </vxe-table>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div style="width:1%"></div>
            <div style="width:14%">
                <table>
                <tr>
                    <td>
                        <el-divider content-position="left">{{$t('getapi[7410]')}}</el-divider>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour0)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7411]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour1)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7412]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour_HourNRate)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7413]')}}{{HourNRate}}%</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour2)" plain size="mini" style="width:160px;text-align: left" @click="exp(2,colour2)">{{$t('getapi[7392]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour3)" plain size="mini" style="width:160px;text-align: left" @click="exp(3,colour3)">{{$t('getapi[7414]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour4)" plain size="mini" style="width:160px;text-align: left" @click="exp(4,colour4)">{{$t('getapi[7415]')}}</el-button>
                    </td>
                </tr>
                <!--<tr>
                    <td>
                        <el-button :type="expscolor(colour_LocalMonthBalance)" plain size="mini" style="width:160px;text-align: left" >收发存上月与本月</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour_CategoryNull)" plain size="mini" style="width:160px;text-align: left" >存货类别1缺失</el-button>
                    </td>
                </tr>-->
                <tr>
                    <td>
                        <el-button :type="expscolor(colour7)" plain size="mini" style="width:160px;text-align: left" @click="exp(7,colour7)">{{$t('getapi[7416]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour8)" plain size="mini" style="width:160px;text-align: left" @click="exp(8,colour8)">{{$t('getapi[7417]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour6)" plain size="mini" style="width:160px;text-align: left" @click="exp(6,colour6)">{{$t('getapi[7418]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour5)" plain size="mini" style="width:160px;text-align: left" @click="exp(5,colour5)">{{$t('getapi[7419]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour9)" plain size="mini" style="width:160px;text-align: left" @click="exp(9,colour9)">{{$t('getapi[7401]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour10)" plain size="mini" style="width:160px;text-align: left" @click="exp(10,colour10)">{{$t('getapi[7402]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour11)" plain size="mini" style="width:160px;text-align: left" @click="exp(11,colour11)">{{$t('getapi[7400]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour12)" plain size="mini" style="width:160px;text-align: left" @click="exp(12,colour12)">{{$t('getapi[7403]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour13)" plain size="mini" style="width:160px;text-align: left" @click="exp(13,colour13)">{{$t('getapi[7404]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour14)" plain size="mini" style="width:160px;text-align: left" @click="exp(14,colour14)">{{$t('getapi[7405]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour15)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7406]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour18)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7408]')}}</el-button>
                    </td>
                </tr>
                <tr>
                    <td>
                        <el-button :type="expscolor(colour20)" plain size="mini" style="width:160px;text-align: left">{{$t('getapi[7409]')}}</el-button>
                    </td>
                </tr>
                </table>
            </div>
        </div>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_bdiscitem',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight-180
            }
        },
        data() {
            return {
                btnexecute:true,//执行按钮
                userData: [], // 用户信息
                costyear: '',
                ismonthsign:false,
                costmonth: '',
                snno:0,//序号
                monthList: [
                    {
                        value: 1,
                        label:1
                    },
                    {
                        value: 2,
                        label:2
                    },
                    {
                        value: 3,
                        label:3
                    },
                    {
                        value: 4,
                        label:4
                    },
                    {
                        value: 5,
                        label:5
                    },
                    {
                        value: 6,
                        label:6
                    },
                    {
                        value: 7,
                        label:7
                    },
                    {
                        value: 8,
                        label:8
                    },
                    {
                        value: 9,
                        label:9
                    },
                    {
                        value: 10,
                        label:10
                    },{
                        value: 11,
                        label:11
                    },
                    {
                        value: 12,
                        label:12
                    }
                ],
                yearList: [],
                dataDetail: {
                },
                btntype0: '',
                dt0:[],
                dt1:[],
                dt2:[],
                dt3:[],
                dt4:[],
                dt5:[],
                dt6:[],
                dt7:[],
                dt8:[],
                dt9:[],
                dt10:[],
                dt11:[],
                dt12:[],
                dt13:[],
                dt14:[],
                dt15:[],
                dt16:[],
                dt17:[],
                dt18:[],
                dt19:[],
                dt20:[],
                colour0:-1,
                colour1:-1,
                colour2:-1,
                colour3:-1,
                colour4:-1,
                colour5:-1,
                colour6:-1,
                colour7:-1,
                colour8:-1,
                colour9:-1,
                colour10:-1,
                colour11:-1,
                colour12:-1,
                colour13:-1,
                colour14:-1,
                colour15:-1,
                colour18:-1,
                colour20:-1,
                TbHeader0:[],
                TbHeader1:[],
                TbHeader2:[],
                TbHeader3:[],
                TbHeader4:[],
                TbHeader5:[],
                TbHeader6:[],
                TbHeader7:[],
                TbHeader8:[],
                TbHeader9:[],
                TbHeader10:[],
                TbHeader11:[],
                TbHeader12:[],
                TbHeader13:[],
                TbHeader14:[],
                TbHeader15:[],
                TbHeader16:[],
                TbHeader17:[],
                TbHeader18:[],
                TbHeader19:[],
                TbHeader20:[],
                HourNRate:-1,
                colour_HourNRate:-1,
                colour_LocalMonthBalance:-1,
                CategoryNull:-1,
                colour_CategoryNull:-1,
                SelectIndex: '0'
            };
        },
        watch: {
            dt0: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt1: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt2: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt3: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt4: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt5: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt6: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt7: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt8: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt9: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt10: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt11: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt12: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt13: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt14: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt15: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt16: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt17: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt18: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt19: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
            dt20: function () {
                let that = this
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(that.SelectIndex)
                    }, 500);
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let year = new Date().getFullYear()
            for(let i=0;i<10;i++){
                that.yearList = [...that.yearList,{
                    value: year - i,
                    label: year - i
                }]
            }
            that.getYearAndMonth()
            that.authority();
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6693]"),this.$t("getapi[6692]"));
            },
            //权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('');
            },
            CheckIsMonthSign(){
                let that=this;
                let parm = {
                        costyear: that.costyear,
                        costmonth: that.costmonth,
                        snno:that.snno
                    }
                    that.$http.urlpost('/Fin/BDiscItem/GetFinAccountPeriod', parm, function (res) {
                        if(res.DataContent==1){
                            that.ismonthsign=false;
                        }
                        else{
                            that.ismonthsign=true;
                        }
                        
                    });
            },
            getYearAndMonth(){
               let that = this
                that.$http.urlpost('/Fin/BDiscItem/GetPeriod', '', function (res) {
                    if (res.Success == 1) {
                        that.costyear = res.DataContent.cboyear;
                        that.costmonth = res.DataContent.cbomonth;
                        
                        let parm = {
                            costyear: that.costyear,
                            costmonth: that.costmonth,
                            snno:that.snno
                        }
                        that.$http.urlpost('/Fin/BDiscItem/GetFinAccountPeriod', parm, function (res) {
                        if(res.DataContent==1){
                            that.ismonthsign=false;
                        }
                        else{
                            that.ismonthsign=true;
                        }
                        
                    });
                    }
                });
            },
            newexecuteBalanceVerify(val){
                let that = this
                that.dt0=[],
                that.dt1=[],
                that.dt2=[],
                that.dt3=[],
                that.dt4=[],
                that.dt5=[],
                that.dt6=[],
                that.dt7=[],
                that.dt8=[],
                that.dt9=[],
                that.dt10=[],
                that.dt11=[],
                that.dt12=[],
                that.dt13=[],
                that.dt14=[],
                that.dt15=[],
                that.dt16=[],
                that.dt17=[],
                that.dt18=[],
                that.dt19=[],
                that.dt20=[],
                that.colour0=-1,
                that.colour1=-1,
                that.colour2=-1,
                that.colour3=-1,
                that.colour4=-1,
                that.colour5=-1,
                that.colour6=-1,
                that.colour7=-1,
                that.colour8=-1,
                that.colour9=-1,
                that.colour10=-1,
                that.colour11=-1,
                that.colour12=-1,
                that.colour13=-1,
                that.colour14=-1,
                that.colour15=-1,
                that.colour18=-1,
                that.colour20=-1,
                that.TbHeader0=[],
                that.TbHeader1=[],
                that.TbHeader2=[],
                that.TbHeader3=[],
                that.TbHeader4=[],
                that.TbHeader5=[],
                that.TbHeader6=[],
                that.TbHeader7=[],
                that.TbHeader8=[],
                that.TbHeader9=[],
                that.TbHeader10=[],
                that.TbHeader11=[],
                that.TbHeader12=[],
                that.TbHeader13=[],
                that.TbHeader14=[],
                that.TbHeader15=[],
                that.TbHeader16=[],
                that.TbHeader17=[],
                that.TbHeader18=[],
                that.TbHeader19=[],
                that.TbHeader20=[],
                that.HourNRate=0,
                that.colour_HourNRate=-1,
                that.colour_LocalMonthBalance=-1,
                that.CategoryNull=-1,
                that.colour_CategoryNull=-1,
                that.snno=0,
                that.executeBalanceVerify(that.snno);
            },
            // 执行检测
            executeBalanceVerify(val){
                 let that = this
                 that.btnexecute=false;//执行按钮灰掉
                if(that.snno<=20){
                    let parm = {
                        costyear: that.costyear,
                        costmonth: that.costmonth,
                        snno:that.snno
                    }
                    that.$http.urlpost('/Fin/BDiscItem/NewExecuteBalanceVerify', parm, function (res) {
                        if (res.Success == 1) {
                            // that.$message.success(res.Msg)
                            // that.dataDetail = res.DataContent;
                            // console.log("序号:"+that.snno)
                            // console.log("返回数据:"+that.snno+":"+JSON.stringify(res.DataContent))
                            
                            if(that.snno==0){
                                that.TbHeader0=res.DataContent.TbHeader0;
                                that.dt0=res.DataContent.dt0;
                                that.colour0=res.DataContent.colour0;
                            }
                            else if(that.snno==1){
                                that.TbHeader1=res.DataContent.TbHeader1;
                                that.dt1=res.DataContent.dt1;
                                that.colour1=res.DataContent.colour1;
                            }
                            else if(that.snno==2){
                                that.HourNRate=res.DataContent.HourNRate;
                                that.colour_HourNRate=res.DataContent.colour_HourNRate;
                            }else if(that.snno==3){
                                that.TbHeader2=res.DataContent.TbHeader2;
                                that.dt2=res.DataContent.dt2;
                                that.colour2=res.DataContent.colour2;

                            }else if(that.snno==4){
                                that.TbHeader3=res.DataContent.TbHeader3;
                                that.dt3=res.DataContent.dt3;
                                that.colour3=res.DataContent.colour3;

                            }else if(that.snno==5){
                                that.TbHeader4=res.DataContent.TbHeader4;
                                that.dt4=res.DataContent.dt4;
                                that.colour4=res.DataContent.colour4;
                            }else if(that.snno==6){
                                that.colour_LocalMonthBalance=res.DataContent.colour_LocalMonthBalance;
                            }else if(that.snno==7){
                                that.CategoryNull=res.DataContent.CategoryNull;
                                that.colour_CategoryNull=res.DataContent.colour_CategoryNull;
                            }
                            else if(that.snno==8){
                                that.TbHeader7=res.DataContent.TbHeader7;
                                that.dt7=res.DataContent.dt7;
                                that.colour7=res.DataContent.colour7;
                            }
                            else if(that.snno==9){
                                that.TbHeader8=res.DataContent.TbHeader8;
                                that.dt8=res.DataContent.dt8;
                                that.colour8=res.DataContent.colour8;
                            }

                            else if(that.snno==10){
                                that.TbHeader6=res.DataContent.TbHeader6;
                                that.dt6=res.DataContent.dt6;
                                that.colour6=res.DataContent.colour6;

                            }else if(that.snno==11){
                                that.TbHeader5=res.DataContent.TbHeader5;
                                that.dt5=res.DataContent.dt5;
                                that.colour5=res.DataContent.colour5;

                            }else if(that.snno==12){
                                that.TbHeader9=res.DataContent.TbHeader9;
                                that.dt9=res.DataContent.dt9;
                                that.colour9=res.DataContent.colour9;

                            }else if(that.snno==13){
                                that.TbHeader10=res.DataContent.TbHeader10;
                                that.dt10=res.DataContent.dt10;
                                that.colour10=res.DataContent.colour10;

                            }else if(that.snno==14){
                                that.TbHeader11=res.DataContent.TbHeader11;
                                that.dt11=res.DataContent.dt11;
                                that.colour11=res.DataContent.colour11;

                            }else if(that.snno==15){
                                that.TbHeader12=res.DataContent.TbHeader12;
                                that.dt12=res.DataContent.dt12;
                                that.colour12=res.DataContent.colour12;

                            }else if(that.snno==16){
                                that.TbHeader13=res.DataContent.TbHeader13;
                                that.dt13=res.DataContent.dt13;
                                that.colour13=res.DataContent.colour13;

                            }else if(that.snno==17){
                                that.TbHeader14=res.DataContent.TbHeader14;
                                that.dt14=res.DataContent.dt14;
                                that.colour14=res.DataContent.colour14;

                            }else if(that.snno==18){
                                that.TbHeader15=res.DataContent.TbHeader15;
                                that.TbHeader16=res.DataContent.TbHeader16;
                                that.TbHeader17=res.DataContent.TbHeader17;
                                that.dt15=res.DataContent.dt15;
                                that.dt16=res.DataContent.dt16;
                                that.dt17=res.DataContent.dt17;
                                that.colour15=res.DataContent.colour15;

                            }else if(that.snno==19){
                                that.TbHeader18=res.DataContent.TbHeader18;
                                that.TbHeader19=res.DataContent.TbHeader19;
                                that.dt18=res.DataContent.dt18;
                                that.dt19=res.DataContent.dt19;
                                that.colour18=res.DataContent.colour18;

                            }else if(that.snno==20){
                                that.TbHeader20=res.DataContent.TbHeader20;
                                that.dt20=res.DataContent.dt20;
                                that.colour20=res.DataContent.colour20;
                            }
                            that.snno=that.snno+1;
                            that.executeBalanceVerify(that.snno+1);
                        }
                    });
                }
                else{
                    that.btnexecute=true;//执行按钮恢复
                    that.$message.success("平衡检测完毕");
                }
            },
            //更新收发存存货类别
            updateBalancePartCategory(){
              let that = this
              let parm = {
                  costyear: that.costyear,
                  costmonth: that.costmonth,
                  LangType:that.$processdata.getLang(),
              }
                that.$http.urlpost('/Fin/BDiscItem/UpdateBalancePartCategory', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 收发存平衡
            avgCostCalc(){
                let that = this
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth,
                    LangType:that.$processdata.getLang(),
                }
                that.$http.urlpost('/Fin/BDiscItem/AvgCostCalc', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            // 回些成本到单据
            writeBackToOrder(){
                let that = this
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth
                }
                that.$http.urlpost('/Fin/BDiscItem/WriteBackToOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            expscolor(val){
                if(val == 0){
                    return ''
                } else if (val == 1){
                    return 'success'
                } else if (val == 2){
                    return 'danger'
                }
            },
            exp(val,type){
                let that = this
                if(type != 2){
                    return false
                }
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth,
                    type : val
                }
                that.loading = true
                that.$http.urlpost('/Fin/BDiscItem/ExecuteBalanceVerifyToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        that.loading = false
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            selectInfo(tab){
                let that = this
                console.log('高度变化')
                that.tableHeight = window.innerHeight - 189
                that.SelectIndex = tab.name
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            updatePur(){
                let that = this
                let parm = {
                    List:that.dt15
                }
                that.$http.urlpost('/Fin/BDiscItem/UpdatePurGrnInvoiceQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            updateSal(){
                let that = this
                let parm = {
                    List:that.dt16
                }
                that.$http.urlpost('/Fin/BDiscItem/UpdateSalOutInvoiceQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            updateIss(){
                let that = this
                let parm = {
                    List:that.dt17
                }
                that.$http.urlpost('/Fin/BDiscItem/UpdateIssGrnInvoiceQty', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            //误差来源
            checkExecuteBalanceVerify(){
                let that = this
                let parm = {
                    costyear: that.costyear,
                    costmonth: that.costmonth,
                    ls:that.dt13
                }
                that.$http.urlpost('Fin/BDiscItem/CheckExecuteBalanceVerify', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[8916]'))
                        that.TbHeader13=res.DataContent.TbHeader13;
                        that.dt13=res.DataContent.dt13;
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-divider--horizontal{
        margin: 12px 0;
    }
</style>
